import { Form as AntForm } from "antd"
import React from "react"
import styled from "styled-components"

import { AuthFormContainer } from "./AuthFormContainer"

const StyledAuthForm = styled(AntForm)`
  text-align: center;
  background-color: white;
  padding: 2rem 0;
`
export const AuthForm = ({
  children,
  ...props
}: React.ComponentProps<typeof AntForm>) => {
  return (
    <AuthFormContainer>
      <StyledAuthForm
        name="basic"
        layout="vertical"
        initialValues={{ remember: true }}
        autoComplete="on"
        requiredMark={false}
        {...props}
      >
        {children}
      </StyledAuthForm>
    </AuthFormContainer>
  )
}
